<!-- eslint-disable vue/no-mutating-props -->
<template>
    <el-dialog
    :visible.sync="visible"
    title="支付确认"
    width="400px"
    center
    :before-close="cancel"
    >
        <div class="content">
          <div>当前订单已审批通过,是否确认支付?</div>
          <div>支付金额: <span>{{ factAmount }}</span>元</div>
        </div>
        <div slot="footer">
          <div class="mt16" style="text-align: center">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="handleOK"
            >确认支付</el-button
          >
          </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'contactus', // 支付确认
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    factAmount: {
      type: Number || String,
      default: '',
    },
  },
  methods: {
    handleOK() {
      this.$emit('ok')
    },
    cancel() {
      this.$emit('close')
    },
  },
}
</script>

  <style lang="scss" scoped>
  .content {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
  }
  </style>
